import { EditPertanyaanPayload } from "../../../../models/Pertanyaan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allPertanyaanKey } from "../../queries/Pertanyaan/useFetchAllPertanyaan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function editPertanyaan(data: EditPertanyaanPayload) {
  const res = await ApiClient.put(`/EditPertanyaan`, data);
  return res.data;
}

export const useEditPertanyaan = mutationWrapper(editPertanyaan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allPertanyaanKey);
  },
});
